import type { EntityContentDto, UpdatePageLayoutDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageLayoutService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  delete = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/page-layout',
    },
    { apiName: this.apiName,...config });
  

  get = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntityContentDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/page-layout',
    },
    { apiName: this.apiName,...config });
  

  update = (input: UpdatePageLayoutDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntityContentDto>({
      method: 'PUT',
      headers: { Accept: 'application/json' },
      url: '/api/app/page-layout',
      body: input,
    },
    { apiName: this.apiName,...config });
}
